import { Injectable, signal, WritableSignal } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PageTitleService {
    private _pageTitle: WritableSignal<string | null> = signal(null);

    /**
     * Signal that emits the current page title from route data
     */
    readonly pageTitle = this._pageTitle.asReadonly();

    constructor(private router: Router, private activatedRoute: ActivatedRoute) {
        // Listen to navigation changes and extract pageTitle from route data
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            const pageTitle = this.getPageTitleFromRoute(this.activatedRoute);
            this._pageTitle.set(pageTitle);
        });

        // Initialize on service creation (defer to ensure route is resolved)
        setTimeout(() => {
            const initialTitle = this.getPageTitleFromRoute(this.activatedRoute);
            this._pageTitle.set(initialTitle);
        });
    }

    /**
     * Recursively traverse the route tree to find pageTitle in route data
     * Deepest child route wins (child overrides parent)
     */
    private getPageTitleFromRoute(route: ActivatedRoute): string | null {
        // Check children first (deepest child wins)
        let pageTitle: string | null = null;
        if (route.firstChild) {
            pageTitle = this.getPageTitleFromRoute(route.firstChild);
            if (pageTitle) {
                return pageTitle;
            }
        }

        // Fall back to current route if no child has a pageTitle
        if (route.snapshot.data['pageTitle']) {
            return route.snapshot.data['pageTitle'];
        }

        return null;
    }
}
